export default __webpack_public_path__ + "static/media/about-image-mobile.d632a144.jpg";